import { inject, injectable } from "inversify";
import {
  AgendamentoResponse,
  AgendamentoStatusResponse,
  type IObterAgendamentosGateway,
  obterAgendamentosGatewayDI
} from "../ports/ObterAgendamentosGateway";
import {
  AgendamentoOutput,
  AgendamentoStatusOutput,
  IObterAgendamentosUseCase,
  ObterAgendamentosOutput
} from "../ports/ObterAgendamentosUseCase";
import Result from "@/core/common/Result";
import "reflect-metadata";
@injectable()
export class ObterAgendamentosUseCaseAdapter
  implements IObterAgendamentosUseCase
{
  constructor(
    @inject(obterAgendamentosGatewayDI)
    private readonly gateway: IObterAgendamentosGateway
  ) {}

  private handleStatusAgendamento(
    status: AgendamentoStatusResponse
  ): AgendamentoStatusOutput {
    const statusOutput: Record<
      AgendamentoStatusResponse,
      AgendamentoStatusOutput
    > = {
      [AgendamentoStatusResponse.None]: AgendamentoStatusOutput.NaoAgendado,
      [AgendamentoStatusResponse.EmConfirmacao]:
        AgendamentoStatusOutput.EmConfirmacao,
      [AgendamentoStatusResponse.Agendado]: AgendamentoStatusOutput.Agendado,
      [AgendamentoStatusResponse.Cancelado]: AgendamentoStatusOutput.Cancelado
    };

    return statusOutput[status];
  }

  private handleAgendamentoOutput(
    input: AgendamentoResponse
  ): AgendamentoOutput {
    return {
      status: this.handleStatusAgendamento(input.agendamentosStatus),
      data: input.dataAgendamento,
      tipo: input.tipo,
      id: input.id
    };
  }

  async execute(): Promise<Result<ObterAgendamentosOutput>> {
    const response = await this.gateway.getAgendamentos();

    if (response.isFailure) return Result.fail(response.error);

    const agendamentos = response
      .getValue()
      .agendamentos.map((agendamento) =>
        this.handleAgendamentoOutput(agendamento)
      );

    return Result.ok({
      agendamentos: agendamentos
    });
  }
}
